import { Authority } from "@techmore/photo-swipe/lib/entity/Authority";

/** ITRI 篩選資料查詢參數 */
export class ITRISearchFilterParam {
  /** 主題分類 生物、生態與環境" */
  subject?: string;
  /** 數位物件類型 "圖像" */
  format?: string;
  /** 資料來源 "Culture_Event" */
  fetchIndex?: string;
  /** 日期區間 "1905-05-01##2000-01-01" */
  dateRange?: string;
  /** 圖像相關授權 "_CC BY-NC_##_PDM_" */
  rights?: string;
  /** 文字相關授權 "CC BY" */
  desRights?: string;
  /** 縣市行政區 "苗栗縣##臺東縣" */
  dist?: string;
  /** 年代區間 "1900~1999" */
  century?: string;
  /** 建檔單位 */
  createDept?: string;
  /** 排除關鍵字 */
  negKeyword?: string;
}

export const SEARCH_PARAM_KEYS = ['subject', 'format', 'fetchIndex', 'startYear', 'endYear', 'rights', 'desRights', 'city', 'dist', 'createDept', 'negKeyword'];

/** 數位物件類型選項 */
export const FORMAT_OPTIONS = [
  {label: '圖片', value: '圖像'},
  {label: '影片', value: '影片'},
  {label: '聲音', value: '聲音'},
  // {label: '文件', value: '文件'},
  // {label: '其他', value: '其他'},
];

/** 主題分類選項 */
export const SUBJECT_OPTIONS = [
  {label: '人物與團體', value: '人物與團體'},
  {label: '藝術與人文', value: '藝術與人文'},
  {label: '社會與政治', value: '社會與政治'},
  {label: '民俗與宗教', value: '民俗與宗教'},
  {label: '產業與經濟', value: '產業與經濟'},
  {label: '空間、地域與遷徙', value: '空間、地域與遷徙'},
  {label: '族群與語言', value: '族群與語言'},
  {label: '生物、生態與環境', value: '生物、生態與環境'},
  {label: '其他', value: '其他'},
];

// /** 資料來源機關選項 */
// export const FETCH_INDEX_OPTIONS = [
//   {label: '收存系統', value: '收存系統'},
//   {label: '文化部典藏網', value: '文化部典藏網'},
//   {label: '台灣故事島', value: '台灣故事島'},
//   {label: '國家文化資產網', value: '國家文化資產網'},
//   {label: '國家文化資料庫', value: '國家文化資料庫'},
//   {label: '國史館', value: '國史館'},
//   {label: '國立故宮博物院', value: '國立故宮博物院'},
//   {label: '台灣文獻館文獻檔案', value: '台灣文獻館文獻檔案'},
//   {label: '國立台灣大學', value: '國立台灣大學'},
//   {label: '國家檔案資訊網', value: '國家檔案資訊網'},
//   {label: '李梅樹紀念館', value: '李梅樹紀念館'},
//   {label: '陳澄波文化基金會', value: '陳澄波文化基金會'},
//   {label: '中國文化大學', value: '中國文化大學'},
//   {label: '吳三連台灣史料基金會', value: '吳三連台灣史料基金會'},
//   {label: '創作區素材', value: '創作區素材'},
// ];

// /** 數位物件授權選項 */
// export const RIGHTS_OPTIONS = [
//   {label: 'PDM', value: '_PDM_'},
//   {label: 'CC0', value: '_CC0_'},
//   {label: 'OGDL', value: '_OGDL_'},
//   {label: 'CC BY', value: '_CC BY_'},
//   {label: 'CC BY-SA', value: '_CC BY-SA_'},
//   {label: 'CC BY-ND', value: '_CC BY-ND_'},
//   {label: 'CC BY-NC', value: '_CC BY-NC_'},
//   {label: 'CC BY-NC-SA', value: '_CC BY-NC-SA_'},
//   {label: 'CC BY-NC-ND', value: '_CC BY-NC-ND_'},
//   {label: '僅限公開瀏覽', value: '_僅限公開瀏覽_'},
// ];
// /** 數位物件開放授權 */
// export const OPENED_RIGHTS = [
//   {label: 'PDM', value: '_PDM_'},
//   {label: 'CC0', value: '_CC0_'},
//   {label: 'OGDL', value: '_OGDL_'},
//   {label: 'CC BY', value: '_CC BY_'},
//   {label: 'CC BY-SA', value: '_CC BY-SA_'},
//   {label: 'CC BY-ND', value: '_CC BY-ND_'},
// ];
// /** 數位物件不可商用授權 */
// export const SHARED_RIGHTS = [
//   {label: 'CC BY-NC', value: '_CC BY-NC_'},
//   {label: 'CC BY-NC-SA', value: '_CC BY-NC-SA_'},
//   {label: 'CC BY-NC-ND', value: '_CC BY-NC-ND_'},
// ];
// /** 數位物件封閉授權 */
// export const CLOSED_RIGHTS = [
//   {label: '僅限公開瀏覽', value: '_僅限公開瀏覽_'},
// ];

// /** 文字授權選項 */
// export const DES_RIGHTS_OPTIONS = [
//   {label: 'PDM', value: 'PDM'},
//   {label: 'CC0', value: 'CC0'},
//   {label: 'OGDL', value: 'OGDL'},
//   {label: 'CC BY', value: 'CC BY'},
//   {label: 'CC BY-SA', value: 'CC BY-SA'},
//   {label: 'CC BY-ND', value: 'CC BY-ND'},
//   {label: 'CC BY-NC', value: 'CC BY-NC'},
//   {label: 'CC BY-NC-SA', value: 'CC BY-NC-SA'},
//   {label: 'CC BY-NC-ND', value: 'CC BY-NC-ND'},
//   {label: '僅限公開瀏覽', value: '僅限公開瀏覽'},
// ];
